import { Badge } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import clsx from 'clsx'
import styles from '../nav.module.scss'

const BenchmarksLink = ({ className, activeClassName, exact, to, children }) => {
  const { benchmark = 0 } = useSelector(
    (state) => ({
      benchmark: state.notifications?.counters?.benchmark,
    }),
    shallowEqual,
  )

  return (
    <NavLink
      className={className}
      activeClassName={activeClassName}
      exact={exact}
      to={to}
    >
      {children}
      {benchmark !== 0 && (
        <Badge
          className={clsx(styles['nav__link-part'], styles['nav__link-badge'])}
          bgColor={'Label-Error-Primary'}
          color={'Label-Onsurface'}
        >
          {benchmark.toString()}
        </Badge>
      )}
    </NavLink>
  )
}
export default BenchmarksLink

BenchmarksLink.propTypes = {
  className: PropTypes.string,
  activeClassName: PropTypes.string,
  exact: PropTypes.bool,
  to: PropTypes.string,
  children: PropTypes.node,
}
